import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import _ from "lodash";
import { api } from "../../../app/applicationSlice";
import { RootState, RootThunk, RootThunkApi } from "../../../app/store";
import { fromJson, revenueReport } from "../../../models/revenueReport"
import * as service from "../../../services/revenueReport";
import { sendAsync } from "../../../app/applicationSlice";
import { revenueReportParams } from "../../../services/revenueReport";

interface RevenueReports {
    revenueReportList: revenueReport[];
}

const initialState: RevenueReports = {
    revenueReportList: [], 
  };

  const revenueReportSlice = createSlice({
    name: "revenueReportSlice",
    initialState,
    reducers: {
      setReportList: (state, action) => {
        state.revenueReportList = action.payload;
      },
    },
  });

  export const {
    setReportList,
  } = revenueReportSlice.actions;


export const selectReportList =(state:RootState) =>state.revenueReport.revenueReportList;

export function getRevenueReportList(params:revenueReportParams): RootThunk {
    return api(service.getRevenueReport(params), (data: any, dispatch) => {
      dispatch(setReportList([data]));
     
    });
  }

  export const getRevenueReportExoprt = createAsyncThunk<
  void,
  revenueReportParams,
  RootThunkApi
>("doctorAudit/getRevenueReportExoprt ", async (params, api) => {
  return sendAsync(service.getRevenueReportExport(params), api);
});


  export default revenueReportSlice.reducer;